import { firebase } from "./firebaseconfig";

const microsoftProvider = () => {
  const provider = new firebase.auth.OAuthProvider("microsoft.com");
  provider.setCustomParameters({
    prompt: "consent",
  });
  
  return provider;
};

export default microsoftProvider;
